var default_styles_default = {
  "button_container": "uVClx",
  "button_text": "YDg1J",
  "button_size_content": "Bz03F"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
